export default __webpack_public_path__ + "static/media/logo_autozug.9f51f686.svg";